import { AbstractGameView } from "@lib/titan2-slingo/dist/game/view/abstract/display/AbstractGameView";
import { EventObject } from "@lib/titan2/dist/util/event/EventObject";
import { TitanSprite } from "@lib/titan2/dist/game/control/TitanSprite";
import { MouseUtil } from "@lib/titan2/dist/util/view/MouseUtil";
import gsap from "gsap";
import { TitanText } from "@lib/titan2/dist/game/control/TitanText";
import { SoundEvent } from "../../../../controller/event/GameEvent";
import { Service } from "@lib/titan2-slingo/dist/api/Service";
import { MouseBlocker } from "@lib/titan2/dist/game/control/MouseBlocker";
import { MouseBlockerProperties } from "@lib/titan2/dist/game/control/properties/MouseBlockerProperties";
export class FeatureSelector extends AbstractGameView {
    constructor(factory, landscapeProperties, portraitProperties) {
        super(factory, landscapeProperties, portraitProperties);
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(FeatureSelectorEvents.REVEAL_CHOICES, this.revealChoices);
        this.registerGame(FeatureSelectorEvents.HIDE_CHOICES, this.hideChoices);
        this.registerGame(FeatureSelectorEvents.REPLAY_EMULATE_CHOICE_CLICK, this.handleReplayEmulateChoiceClick);
    }
    create() {
        super.create();
        this.backgroundShading = new MouseBlocker(new MouseBlockerProperties(0x000000, 0.7));
        this.addChild(this.backgroundShading);
        this.pickBonusText = TitanText.createField(this, this.landscapeProperties.pickBonusText, this.portraitProperties.pickBonusText);
        this.pickBonusText.setText("PICK A BONUS!");
        this.choiceContainer1 = new AbstractGameView(this.factory, this.landscapeProperties.choice1Container, this.portraitProperties.choice1Container);
        this.addChild(this.choiceContainer1);
        this.choiceSprites1 = {
            down: TitanSprite.createSprite(this.choiceContainer1, "down", this.landscapeProperties.choice1Down, this.portraitProperties.choice1Down),
            up: TitanSprite.createSprite(this.choiceContainer1, "up", this.landscapeProperties.choice1Up, this.portraitProperties.choice1Up),
            over: TitanSprite.createSprite(this.choiceContainer1, "over", this.landscapeProperties.choice1Over, this.portraitProperties.choice1Over),
        };
        this.choiceText1 = TitanText.createField(this.choiceContainer1, "choice-goldfish", this.landscapeProperties.choiceText, this.portraitProperties.choiceText);
        this.choiceText1.setText(this.langManager.getLang("GameLang.BONUS_SELECT_LINE2"), true);
        this.choiceContainer2 = new AbstractGameView(this.factory, this.landscapeProperties.choice2Container, this.portraitProperties.choice2Container);
        this.addChild(this.choiceContainer2);
        this.choiceSprites2 = {
            down: TitanSprite.createSprite(this.choiceContainer2, "down", this.landscapeProperties.choice2Down, this.portraitProperties.choice2Down),
            up: TitanSprite.createSprite(this.choiceContainer2, "up", this.landscapeProperties.choice2Up, this.portraitProperties.choice2Up),
            over: TitanSprite.createSprite(this.choiceContainer2, "over", this.landscapeProperties.choice2Over, this.portraitProperties.choice2Over),
        };
        this.choiceText2 = TitanText.createField(this.choiceContainer2, "choice-fishfood", this.landscapeProperties.choiceText, this.portraitProperties.choiceText);
        this.choiceText2.setText(this.langManager.getLang("GameLang.BONUS_SELECT_LINE1"), true);
        this.reset();
        MouseUtil.addMouseDown(this.choiceContainer1, () => this.handleMouseDown(0), undefined);
        MouseUtil.addMouseDown(this.choiceContainer2, () => this.handleMouseDown(1), undefined);
        MouseUtil.addMouseOver(this.choiceContainer1, () => this.handleMouseOver(0), this);
        MouseUtil.addMouseOver(this.choiceContainer2, () => this.handleMouseOver(1), this);
        MouseUtil.addMouseOut(this.choiceContainer1, () => this.handleMouseOut(0), this);
        MouseUtil.addMouseOut(this.choiceContainer2, () => this.handleMouseOut(1), this);
        this.visible = false;
        this.alpha = 0;
        MouseUtil.setInteractive(this.choiceContainer1, false);
        MouseUtil.setInteractive(this.choiceContainer2, false);
    }
    handleMouseDown(pick) {
        console.log("Picked Feature ", pick);
        this.dispatchGame(SoundEvent.CLICK);
        const isChoice1 = pick === 0;
        this.choiceSprites1.over.visible = false;
        this.choiceSprites2.over.visible = false;
        this.choiceSprites1.down.visible = isChoice1;
        this.choiceSprites2.down.visible = !isChoice1;
        this.choiceSprites1.up.visible = !isChoice1;
        this.choiceSprites2.up.visible = isChoice1;
        MouseUtil.setInteractive(this.choiceContainer1, false);
        MouseUtil.setInteractive(this.choiceContainer2, false);
        this.dispatchGame(new EventObject(FeatureSelectorEvents.FEATURE_PICKED.getType(), { pick }));
    }
    handleMouseOver(pick) {
        if (pick === 0) {
            this.choiceSprites1.over.visible = true;
            this.choiceSprites1.up.visible = false;
        }
        else {
            this.choiceSprites2.over.visible = true;
            this.choiceSprites2.up.visible = false;
        }
    }
    handleMouseOut(pick) {
        if (pick === 0) {
            this.choiceSprites1.over.visible = false;
            this.choiceSprites1.up.visible = true;
        }
        else {
            this.choiceSprites2.over.visible = false;
            this.choiceSprites2.up.visible = true;
        }
    }
    revealChoices() {
        gsap.to(this, {
            delay: 1,
            alpha: 1,
            duration: 1,
            onStart: () => this.visible = true,
            onComplete: () => {
                MouseUtil.setInteractive(this.choiceContainer1, !Service.isReplay());
                MouseUtil.setInteractive(this.choiceContainer2, !Service.isReplay());
                this.dispatchGame(FeatureSelectorEvents.CHOICES_REVEALED);
            }
        });
    }
    handleReplayEmulateChoiceClick(event) {
        const choice = event.getPayload().choice;
        this.handleMouseOver(choice);
        gsap.delayedCall(0.25, () => this.handleMouseDown(choice));
        gsap.delayedCall(0.5, () => this.handleMouseOut(choice));
    }
    hideChoices() {
        if (this.alpha > 0) {
            gsap.to(this, {
                duration: 0.5,
                delay: 1,
                alpha: 0,
                onComplete: () => {
                    this.visible = false;
                    this.reset();
                    this.dispatchGame(FeatureSelectorEvents.HIDE_CHOICES_COMPLETE);
                }
            });
        }
    }
    reset() {
        this.choiceSprites1.over.visible = false;
        this.choiceSprites2.over.visible = false;
        this.choiceSprites1.down.visible = false;
        this.choiceSprites2.down.visible = false;
        this.choiceSprites1.up.visible = true;
        this.choiceSprites2.up.visible = true;
    }
}
export class FeatureSelectorEvents {
}
FeatureSelectorEvents.REPLAY_EMULATE_CHOICE_CLICK = new EventObject("FeatureSelectorEvents.REPLAY_EMULATE_CHOICE_CLICK");
FeatureSelectorEvents.REVEAL_CHOICES = new EventObject("FeatureSelectorEvents.REVEAL_CHOICES");
FeatureSelectorEvents.CHOICES_REVEALED = new EventObject("FeatureSelectorEvents.CHOICES_REVEALED");
FeatureSelectorEvents.FEATURE_PICKED = new EventObject("FeatureSelectorEvents.FEATURE_PICKED");
FeatureSelectorEvents.HIDE_CHOICES = new EventObject("FeatureSelectorEvents.HIDE_CHOICES");
FeatureSelectorEvents.HIDE_CHOICES_COMPLETE = new EventObject("FeatureSelectorEvents.HIDE_CHOICES_COMPLETE");
//# sourceMappingURL=FeatureSelector.js.map